export const tonerStyle = [
    {
        id: 'background',
        metadata: { layer_type: 'base_map' },
        paint: {
            'background-color': '#fff'
        },
        type: 'background'
    },
    {
        filter: ['==', 'class', 'grass'],
        id: 'landcover_grass_fill',
        metadata: { layer_type: 'base_map' },
        minzoom: 10,
        paint: {
            'fill-antialias': true,
            'fill-color': {
                stops: [
                    [10, 'rgba(0, 0, 0, 0.3)'],
                    [16, 'rgba(0, 0, 0, 1)']
                ]
            },
            'fill-opacity': 1,
            'fill-outline-color': 'rgba(0, 0, 0, 0)'
        },
        source: 'openmaptiles',
        'source-layer': 'landcover',
        type: 'fill'
    },
    {
        filter: ['==', 'class', 'grass'],
        id: 'landcover_grass_pattern',
        metadata: { layer_type: 'base_map' },
        minzoom: 10,
        paint: {
            'fill-antialias': true,
            'fill-opacity': {
                stops: [
                    [10, 0.75],
                    [14, 1]
                ]
            },
            'fill-outline-color': 'rgba(94, 94, 94, 0)',
            'fill-pattern': 'dash-t'
        },
        source: 'openmaptiles',
        'source-layer': 'landcover',
        type: 'fill'
    },
    {
        filter: ['==', 'class', 'wood'],
        id: 'landcover_wood_fill',
        metadata: { layer_type: 'base_map' },
        minzoom: 10,
        paint: {
            'fill-antialias': true,
            'fill-color': 'rgba(0, 0, 0, 1)',
            'fill-opacity': 1
        },
        source: 'openmaptiles',
        'source-layer': 'landcover',
        type: 'fill'
    },
    {
        filter: ['==', 'class', 'wood'],
        id: 'landcover_wood_pattern',
        metadata: { layer_type: 'base_map' },
        layout: {
            visibility: 'visible'
        },
        minzoom: 10,
        paint: {
            'fill-antialias': true,
            'fill-color': 'rgba(0, 0, 0, 1)',
            'fill-opacity': 1,
            'fill-pattern': 'dots-t'
        },
        source: 'openmaptiles',
        'source-layer': 'landcover',
        type: 'fill'
    },
    {
        filter: ['all', ['==', 'class', 'cemetery']],
        id: 'landcover_cemetery_fill',
        metadata: { layer_type: 'base_map' },
        minzoom: 10,
        paint: {
            'fill-antialias': true,
            'fill-color': 'rgba(156, 156, 156, 1)',
            'fill-opacity': {
                stops: [
                    [10, 0.75],
                    [14, 1]
                ]
            },
            'fill-outline-color': 'rgba(75, 75, 75, 1)'
        },
        source: 'openmaptiles',
        'source-layer': 'landuse',
        type: 'fill'
    },
    {
        filter: ['all', ['==', 'class', 'cemetery']],
        id: 'landcover_cemetery_pattern',
        metadata: { layer_type: 'base_map' },
        paint: {
            'fill-antialias': true,
            'fill-color': 'rgba(236, 235, 235, 0)',
            'fill-opacity': {
                stops: [
                    [10, 0.75],
                    [14, 1]
                ]
            },
            'fill-outline-color': 'rgba(75, 75, 75, 0)',
            'fill-pattern': 'cross-t'
        },
        source: 'openmaptiles',
        'source-layer': 'landuse',
        type: 'fill'
    },
    {
        filter: [
            'all',
            ['!=', 'brunnel', 'tunnel'],
            ['==', '$type', 'Polygon'],
            ['!=', 'intermittent', 1]
        ],
        id: 'water',
        metadata: { layer_type: 'base_map' },
        layout: {
            visibility: 'visible'
        },
        paint: {
            'fill-antialias': true,
            'fill-color': 'rgba(0, 0, 0, 1)'
        },
        source: 'openmaptiles',
        'source-layer': 'water',
        type: 'fill'
    },
    {
        filter: ['all', ['!=', 'class', 'river']],
        id: 'waterway',
        metadata: { layer_type: 'base_map' },
        minzoom: 12,
        source: 'openmaptiles',
        'source-layer': 'waterway',
        type: 'line'
    },
    {
        filter: ['all', ['==', 'class', 'rail']],
        id: 'rail',
        metadata: { layer_type: 'base_map' },
        layout: {
            visibility: 'visible'
        },
        minzoom: 13,
        paint: {
            'line-color': {
                stops: [
                    [13, 'rgba(216, 216, 216, 1)'],
                    [17, 'rgba(38, 38, 38, 1)']
                ]
            },
            'line-width': {
                stops: [
                    [13, 0.85],
                    [17, 2]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'line'
    },
    {
        filter: ['all', ['==', 'class', 'rail']],
        id: 'rail_hatch',
        metadata: { layer_type: 'base_map' },
        layout: {
            visibility: 'visible'
        },
        minzoom: 15,
        paint: {
            'line-color': 'rgba(38, 38, 38, 1)',
            'line-dasharray': {
                stops: [
                    [15, [0.2, 0.8]],
                    [17, [0.2, 1]]
                ]
            },
            'line-width': {
                stops: [
                    [15, 2],
                    [17, 6]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'line'
    },
    {
        filter: [
            'all',
            ['==', '$type', 'Polygon'],
            ['==', 'brunnel', 'bridge']
        ],
        id: 'road_area_bridge',
        metadata: { layer_type: 'base_map' },
        layout: {
            visibility: 'visible'
        },
        paint: {
            'fill-antialias': true,
            'fill-color': 'rgba(255, 255, 255, 1)',
            'fill-opacity': 1
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'fill'
    },
    {
        filter: ['all', ['==', '$type', 'Polygon'], ['==', 'class', 'pier']],
        id: 'road_area_pier',
        layout: {
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        paint: {
            'fill-antialias': true,
            'fill-color': 'rgba(255, 255, 255, 1)',
            'fill-opacity': 1
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'fill'
    },
    {
        filter: ['all', ['==', '$type', 'LineString'], ['in', 'class', 'pier']],
        id: 'road_pier',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        paint: {
            'line-color': 'rgba(255, 255, 255, 1)',
            'line-width': {
                base: 1.2,
                stops: [
                    [15, 1],
                    [17, 4]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'line'
    },
    {
        filter: ['all', ['==', '$type', 'LineString'], ['==', 'class', 'path']],
        id: 'road_path',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        minzoom: 15,
        paint: {
            'line-color': 'rgba(255, 255, 255, 1)',
            'line-width': {
                stops: [
                    [14, 2],
                    [17, 4]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'line'
    },
    {
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['!in', 'class', 'pier', 'rail', 'path', 'primary'],
            ['in', 'class', 'secondary', 'tertiary', 'minor', 'service']
        ],
        id: 'road_secondary',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        minzoom: 10,
        paint: {
            'line-color': {
                stops: [
                    [10, 'rgba(0, 0, 0, 0.3)'],
                    [12, 'rgba(0, 0, 0, 0.5)'],
                    [15, 'rgba(0, 0, 0, 1)']
                ]
            },
            'line-width': {
                stops: [
                    [13, 0.5],
                    [15, 3],
                    [17, 8]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'line'
    },
    {
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['!in', 'class', 'pier', 'rail', 'path'],
            ['==', 'class', 'primary']
        ],
        id: 'road_primary',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        minzoom: 8,
        paint: {
            'line-color': {
                stops: [
                    [8, 'rgba(0, 0, 0, 0.19)'],
                    [10, 'rgba(0, 0, 0, 0.6)'],
                    [17, 'rgba(0, 0, 0, 1)']
                ]
            },
            'line-width': {
                stops: [
                    [12, 0.75],
                    [15, 6],
                    [17, 8]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'line'
    },
    {
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['!in', 'class', 'pier', 'path', 'rail'],
            ['in', 'class', 'motorway', 'trunk']
        ],
        id: 'road_highway_casing',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        minzoom: 8,
        paint: {
            'line-color': {
                stops: [
                    [6, 'rgba(219, 219, 219, 1)'],
                    [10, 'rgba(255, 255, 255, 1)'],
                    [16, 'rgba(255, 255, 255, 1)']
                ]
            },
            'line-opacity': 1,
            'line-width': {
                stops: [
                    [10, 4],
                    [16, 16]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'line'
    },
    {
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['!in', 'class', 'pier', 'path', 'rail'],
            ['in', 'class', 'motorway', 'trunk']
        ],
        id: 'road_highway',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        minzoom: 6,
        paint: {
            'line-color': {
                stops: [
                    [6, 'rgba(0, 0, 0, 0.02)'],
                    [10, 'rgba(0, 0, 0, 0.6)'],
                    [16, 'rgba(0, 0, 0, 1)']
                ]
            },
            'line-opacity': 1,
            'line-width': {
                stops: [
                    [7, 1],
                    [10, 2],
                    [16, 8]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        type: 'line'
    },
    {
        id: 'building_fill',
        layout: {
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        minzoom: 16,
        paint: {
            'fill-antialias': true,
            'fill-color': 'rgba(0, 0, 0, 1)',
            'fill-opacity': {
                base: 1,
                stops: [
                    [13, 0],
                    [16, 1]
                ]
            },
            'fill-outline-color': 'rgba(0, 0, 0, 1)'
        },
        source: 'openmaptiles',
        'source-layer': 'building',
        type: 'fill'
    },
    {
        id: 'building_pattern',
        layout: {
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        minzoom: 14,
        paint: {
            'fill-color': 'rgba(0, 0, 0, 1)',
            'fill-opacity': {
                base: 1,
                stops: [
                    [13, 0],
                    [16, 1]
                ]
            },
            'fill-outline-color': 'rgba(0, 0, 0, 1)',
            'fill-pattern': 'hatch-t'
        },
        source: 'openmaptiles',
        'source-layer': 'building',
        type: 'fill'
    },
    {
        filter: ['all', ['==', 'admin_level', 4]],
        id: 'boundary_state',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible'
        },
        maxzoom: 14,
        metadata: { layer_type: 'base_map' },
        minzoom: 3,
        paint: {
            'line-color': {
                stops: [
                    [5, 'rgba(80, 80, 80, 1)'],
                    [6, 'rgba(0, 0, 0, 1)']
                ]
            },
            'line-dasharray': {
                stops: [
                    [5, [1, 1]],
                    [6, [1, 2]]
                ]
            },
            'line-opacity': 1,
            'line-width': {
                base: 1.3,
                stops: [
                    [5, 1],
                    [6, 1.2],
                    [7, 1.6],
                    [14, 5]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'boundary',
        type: 'line'
    },
    {
        filter: ['==', 'admin_level', 2],
        id: 'boundary_country_z5-',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible'
        },
        metadata: { layer_type: 'base_map' },
        minzoom: 5,
        paint: {
            'line-color': 'rgba(0, 0, 0, 1)',
            'line-width': {
                stops: [
                    [3, 1.5],
                    [7, 3],
                    [22, 6]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'boundary',
        type: 'line'
    },
    {
        filter: ['all', ['==', 'admin_level', 2], ['!has', 'claimed_by']],
        id: 'boundary_country_z0-4',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible'
        },
        maxzoom: 5,
        metadata: { layer_type: 'base_map' },
        minzoom: 2,
        paint: {
            'line-blur': 0,
            'line-color': 'rgba(0, 0, 0, 1)',
            'line-opacity': 1,
            'line-width': {
                base: 1.1,
                stops: [
                    [2, 1],
                    [22, 20]
                ]
            }
        },
        source: 'openmaptiles',
        'source-layer': 'boundary',
        type: 'line'
    },
    {
        filter: ['all', ['==', '$type', 'LineString'], ['has', 'name']],
        id: 'water_name_lakeline',
        metadata: { layer_type: 'base_map' },
        layout: {
            'symbol-placement': 'line',
            'symbol-spacing': 350,
            'text-field': '{name:latin} {name:nonlatin}',
            'text-font': ['Noto Sans Italic'],
            'text-letter-spacing': 0.2,
            'text-max-width': 5,
            'text-rotation-alignment': 'map',
            'text-size': 14,
            visibility: 'visible'
        },
        minzoom: 7,
        paint: {
            'text-color': 'rgba(255, 255, 255, 1)'
        },
        source: 'openmaptiles',
        'source-layer': 'water_name',
        type: 'symbol'
    },
    {
        filter: ['all', ['==', '$type', 'LineString'], ['has', 'name']],
        id: 'water_name_way',
        metadata: { layer_type: 'base_map' },
        layout: {
            'symbol-placement': 'line',
            'symbol-spacing': 200,
            'text-field': '{name:latin} {name:nonlatin}',
            'text-font': ['Noto Sans Bold Italic'],
            'text-max-width': 9,
            'text-rotation-alignment': 'map',
            'text-size': {
                stops: [
                    [14, 12],
                    [18, 19]
                ]
            },
            visibility: 'visible'
        },
        minzoom: 14,
        paint: {
            'text-color': 'rgba(255, 255, 255, 1)'
        },
        source: 'openmaptiles',
        'source-layer': 'waterway',
        type: 'symbol'
    },
    {
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['!in', 'class', 'ocean', 'lake']
        ],
        id: 'water_name_sea',
        metadata: { layer_type: 'base_map' },
        layout: {
            'symbol-placement': 'point',
            'symbol-spacing': 250,
            'text-field': '{name:latin} {name:nonlatin}',
            'text-font': ['Noto Sans Italic'],
            'text-letter-spacing': 0.1,
            'text-max-width': 6,
            'text-rotation-alignment': 'map',
            'text-size': 14,
            'text-transform': 'none'
        },
        minzoom: 4,
        paint: {
            'text-color': 'rgba(255, 255, 255, 1)'
        },
        source: 'openmaptiles',
        'source-layer': 'water_name',
        type: 'symbol'
    },
    {
        filter: ['all', ['==', '$type', 'Point'], ['==', 'class', 'ocean']],
        id: 'water_name_ocean',
        metadata: { layer_type: 'base_map' },
        layout: {
            'symbol-placement': 'point',
            'symbol-spacing': 350,
            'text-field': '{name:latin} {name:nonlatin}',
            'text-font': ['Noto Sans Italic'],
            'text-letter-spacing': 0.2,
            'text-max-width': 5,
            'text-rotation-alignment': 'map',
            'text-size': 14,
            'text-transform': 'uppercase'
        },
        minzoom: 2,
        paint: {
            'text-color': 'rgba(255, 255, 255, 1)'
        },
        source: 'openmaptiles',
        'source-layer': 'water_name',
        type: 'symbol'
    },
    {
        filter: ['in', 'class', 'primary', 'secondary', 'tertiary', 'trunk'],
        id: 'road_label_primary',
        metadata: { layer_type: 'base_map' },
        layout: {
            'symbol-placement': 'line',
            'text-field': '{name:latin} {name:nonlatin}',
            'text-font': {
                stops: [
                    [6, ['Noto Sans Regular']],
                    [16, ['Noto Sans Bold']]
                ]
            },
            'text-keep-upright': true,
            'text-rotation-alignment': 'map',
            'text-size': {
                base: 1,
                stops: [
                    [13, 12],
                    [14, 13]
                ]
            },
            visibility: 'visible'
        },
        minzoom: 15,
        paint: {
            'text-color': 'rgba(0, 0, 0, 1)',
            'text-halo-blur': 0,
            'text-halo-color': 'rgba(255, 255, 255, 1)',
            'text-halo-width': 3
        },
        source: 'openmaptiles',
        'source-layer': 'transportation_name',
        type: 'symbol'
    },
    {
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['in', 'class', 'minor', 'service', 'track']
        ],
        id: 'road_label_secondary',
        metadata: { layer_type: 'base_map' },
        layout: {
            'symbol-placement': 'line',
            'text-field': '{name:latin} {name:nonlatin}',
            'text-font': {
                stops: [
                    [6, ['Noto Sans Regular']],
                    [16, ['Noto Sans Bold']]
                ]
            },
            'text-rotation-alignment': 'map',
            'text-size': {
                base: 1,
                stops: [
                    [13, 12],
                    [14, 13]
                ]
            },
            visibility: 'visible'
        },
        minzoom: 14.5,
        paint: {
            'text-color': 'rgba(0, 0, 0, 1)',
            'text-halo-color': 'rgba(255, 255, 255, 1)',
            'text-halo-width': 3
        },
        source: 'openmaptiles',
        'source-layer': 'transportation_name',
        type: 'symbol'
    },
    {
        filter: ['all'],
        id: 'place_label_park',
        metadata: { layer_type: 'base_map' },
        layout: {
            'symbol-placement': 'point',
            'text-field': '{name:latin}',
            'text-font': ['Noto Sans Italic'],
            'text-line-height': 1,
            'text-pitch-alignment': 'map',
            'text-size': 12,
            visibility: 'visible'
        },
        minzoom: 11,
        paint: {
            'icon-halo-width': 1,
            'text-color': 'rgba(0, 0, 0, 1)',
            'text-halo-color': 'rgba(255, 255, 255, 1)',
            'text-halo-width': 2
        },
        source: 'openmaptiles',
        'source-layer': 'park',
        type: 'symbol'
    },
    {
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['in', 'class', 'village', 'hamlet']
        ],
        id: 'place_label_village',
        metadata: { layer_type: 'base_map' },
        layout: {
            'text-anchor': 'center',
            'text-field': '{name:latin} {name:nonlatin}',
            'text-font': {
                stops: [
                    [12, ['Nunito Regular']],
                    [16, ['Nunito Semi Bold']]
                ]
            },
            'text-max-width': 10,
            'text-size': {
                stops: [
                    [12, 12],
                    [16, 18]
                ]
            },
            visibility: 'visible'
        },
        minzoom: 12,
        paint: {
            'text-color': 'rgba(11, 11, 11, 1)',
            'text-halo-blur': 0,
            'text-halo-color': 'hsl(0, 0%, 100%)',
            'text-halo-width': 2
        },
        source: 'openmaptiles',
        'source-layer': 'place',
        type: 'symbol'
    },
    {
        filter: ['all', ['==', '$type', 'Point'], ['==', 'class', 'city']],
        id: 'place_label_city',
        metadata: { layer_type: 'base_map' },
        layout: {
            'icon-anchor': 'center',
            'text-field': '{name:latin}',
            'text-font': {
                stops: [
                    [4, ['Nunito Regular']],
                    [7, ['Nunito Bold']]
                ]
            },
            'text-max-width': 10,
            'text-size': {
                stops: [
                    [4, 14],
                    [7, 15],
                    [8, 19],
                    [16, 22]
                ]
            },
            visibility: 'visible'
        },
        maxzoom: 16,
        minzoom: 4,
        paint: {
            'icon-translate': [1, 11],
            'text-color': 'rgba(0, 0, 0, 1)',
            'text-halo-blur': 0,
            'text-halo-color': 'rgba(255, 255, 255, 1)',
            'text-halo-width': 2
        },
        source: 'openmaptiles',
        'source-layer': 'place',
        type: 'symbol'
    },
    {
        filter: ['all', ['==', '$type', 'Point'], ['==', 'class', 'town']],
        id: 'place_label_town',
        metadata: { layer_type: 'base_map' },
        layout: {
            'icon-anchor': 'center',
            'text-field': '{name:latin}',
            'text-font': {
                stops: [
                    [8, ['Nunito Regular']],
                    [14, ['Nunito Bold']]
                ]
            },
            'text-max-width': 10,
            'text-size': {
                stops: [
                    [8, 15],
                    [16, 18]
                ]
            },
            visibility: 'visible'
        },
        maxzoom: 16,
        minzoom: 10,
        paint: {
            'icon-translate': [1, 11],
            'text-color': 'rgba(0, 0, 0, 1)',
            'text-halo-blur': 0,
            'text-halo-color': 'rgba(255, 255, 255, 1)',
            'text-halo-width': 2
        },
        source: 'openmaptiles',
        'source-layer': 'place',
        type: 'symbol'
    },
    {
        filter: ['all', ['==', 'class', 'state']],
        id: 'place_state-label',
        metadata: { layer_type: 'base_map' },
        layout: {
            'text-field': '{name:latin} {name:nonlatin}',
            'text-font': ['Nunito Semi Bold'],
            'text-max-width': 10,
            'text-size': 13,
            'text-transform': 'uppercase',
            visibility: 'visible'
        },
        minzoom: 4,
        paint: {
            'text-color': 'rgba(0, 0, 0, 1)'
        },
        source: 'openmaptiles',
        'source-layer': 'place',
        type: 'symbol'
    },
    {
        filter: ['==', 'class', 'country'],
        id: 'place_label_country',
        metadata: { layer_type: 'base_map' },
        layout: {
            'text-allow-overlap': false,
            'text-field': '{name:latin}',
            'text-font': {
                stops: [
                    [3, ['Nunito Regular']],
                    [4, ['Nunito Bold']]
                ]
            },
            'text-ignore-placement': false,
            'text-max-width': 10,
            'text-padding': 2,
            'text-pitch-alignment': 'map',
            'text-size': {
                stops: [
                    [3, 14],
                    [4, 16],
                    [5, 21]
                ]
            },
            'text-transform': 'none',
            visibility: 'visible'
        },
        minzoom: 2,
        paint: {
            'text-color': 'rgba(0, 0, 0, 1)',
            'text-halo-color': '#fff',
            'text-halo-width': 2
        },
        source: 'openmaptiles',
        'source-layer': 'place',
        type: 'symbol'
    },
    {
        filter: ['==', 'class', 'continent'],
        id: 'place_label_continent',
        metadata: { layer_type: 'base_map' },
        layout: {
            'text-field': '{name:latin}',
            'text-font': ['Nunito Extra Bold'],
            'text-line-height': 1.1,
            'text-max-width': 10,
            'text-size': {
                stops: [
                    [3, 18],
                    [4, 24]
                ]
            },
            visibility: 'visible'
        },
        maxzoom: 2,
        minzoom: 1,
        paint: {
            'text-color': 'rgba(0, 0, 0, 1)',
            'text-halo-color': '#fff',
            'text-halo-width': 2
        },
        source: 'openmaptiles',
        'source-layer': 'place',
        type: 'symbol'
    }
]
